( function( $ ) {
	'use strict';

	$( function() {
		const $resultsCarousel = $( '.js-results-carousel' );
		const prevButton = $( '.js-results-carousel-button-prev' );
		const nextButton = $( '.js-results-carousel-button-next' );
		const $counter = $( '.js-results-carousel-counter' );

		$resultsCarousel.on( 'changed.owl.carousel', function( event ) {
			let carousel = event.relatedTarget;

			$counter.text( `${carousel.relative(carousel.current()) + 1} / ${carousel.items().length}` );
		} );

		$resultsCarousel.owlCarousel( {
			items: 1,
			dots: true,
			dotsContainer: '.js-results-carousel-dots',
			nav: false,
			margin: 30,
			responsive: {
				580: {
					items: 2
				},
				1300: {
					items: 3,
					margin: 40
				}
			}
		} );

		prevButton.on( 'click', function() {
			$resultsCarousel.trigger( 'prev.owl.carousel' );
		} );

		nextButton.on( 'click', function() {
			$resultsCarousel.trigger( 'next.owl.carousel' );
		} );

	} );
} )( jQuery );
